import { render, staticRenderFns } from "./SavedPostsFilledIcon.vue?vue&type=template&id=b0abf742&scoped=true"
import script from "./SavedPostsFilledIcon.vue?vue&type=script&lang=js"
export * from "./SavedPostsFilledIcon.vue?vue&type=script&lang=js"
import style0 from "./SavedPostsFilledIcon.vue?vue&type=style&index=0&id=b0abf742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0abf742",
  null
  
)

export default component.exports